'use client';

import {useEffect} from 'react';

import {AppType} from '@web-catalog/types';

import {useSetHeaderAppType} from '@web-catalog/store';

export const HeaderAppTypeSetter = ({appType}: {appType: AppType | null}) => {
  const setAppType = useSetHeaderAppType();
  useEffect(() => {
    setAppType(appType);
  }, [appType, setAppType]);
  return null;
};
